import English from '@/assets/edit/flag/English.png';
import French from '@/assets/edit/flag/French.png';
import Spanish from '@/assets/edit/flag/Spanish.png';
import German from '@/assets/edit/flag/German.png';
import Arabic from '@/assets/edit/flag/Arabic.png';

import Japanese from '@/assets/edit/flag/Japanese.png';
import Chinese from '@/assets/edit/flag/Chinese.png';
import Korean from '@/assets/edit/flag/Korean.png';
import Russian from '@/assets/edit/flag/Russian.png';
import Dutch from '@/assets/edit/flag/Dutch.png';
import Italian from '@/assets/edit/flag/Italian.png';
import Polish from '@/assets/edit/flag/Polish.png';
import Portuguese from '@/assets/edit/flag/Portuguese.png';

export const langeImages = [
  {
    id: 'en',
    name: 'English',
    image: English,
  },
  {
    id: 'fr',
    name: 'French',
    image: French,
  },
  {
    id: 'es',
    name: 'Spanish',
    image: Spanish,
  },
  {
    id: 'de',
    name: 'German',
    image: German,
  },
  {
    id: 'ar',
    name: 'Arabic',
    image: Arabic,
  },
  {
    id: 'ja',
    name: 'Japanese',
    image: Japanese,
  },
  {
    id: 'zh',
    name: 'Chinese',
    image: Chinese,
  },
  {
    id: 'ko',
    name: 'Korean',
    image: Korean,
  },
  {
    id: 'ru',
    name: 'Russian',
    image: Russian,
  },
  {
    id: 'nl',
    name: 'Dutch',
    image: Dutch,
  },
  {
    id: 'it',
    name: 'Italian',
    image: Italian,
  },
  {
    id: 'pl',
    name: 'Polish',
    image: Polish,
  },
  {
    id: 'pt',
    name: 'Portuguese',
    image: Portuguese,
  },
];
